import { Pagination } from '@common/types/service';
import { djangoCmsApi } from '@services/djangoCmsApi';
import { IVideoListDto } from '@videos/types';

const videoAPi = djangoCmsApi.injectEndpoints({
    endpoints: (builder) => ({
        getVideos: builder.query<
            IVideoListDto,
            Pagination & {
                highlighted?: boolean;
                requestCache?: RequestCache;
            }
        >({
            query: ({ requestCache, ...params }) => {
                return {
                    url: 'youtube-videos/',
                    params,
                    cache: requestCache,
                };
            },
            providesTags: (result) => {
                if (result && result.results) {
                    return [
                        ...result.results.map(({ youtube_video_id }) => ({
                            type: 'Videos',
                            id: youtube_video_id,
                        })),
                        { type: 'Videos', id: 'LIST' },
                    ];
                } else {
                    return [{ type: 'Videos', id: 'LIST' }];
                }
            },
        }),
    }),
});

export const { useGetVideosQuery, useLazyGetVideosQuery } = videoAPi;
export default videoAPi;
